import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import { AppErrorBoundary } from './components/app-error-boundary.jsx';
const AdminApp = lazy(() => import('./pages/AdminApp.jsx'));
import WorkstationApp from './pages/WorkstationApp.jsx';

const path = window.location.pathname.replace(/\/+$/, '');
const isAdmin = path === '/admin';

document.title = isAdmin ? '管理后台' : '工作台';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppErrorBoundary><Suspense fallback={<div className="app-loading">正在加载后台...</div>}>{isAdmin ? <AdminApp /> : <WorkstationApp />}</Suspense></AppErrorBoundary>
  </React.StrictMode>,
);
